import { render, staticRenderFns } from "./UkplMenu.vue?vue&type=template&id=3c0affdb"
import script from "./UkplMenu.vue?vue&type=script&lang=js"
export * from "./UkplMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports